import type { FaireProductEntity } from "../../entity_types/product";

export const p_9endjgemtm: FaireProductEntity = {
  token: "p_9endjgemtm",
  type: "product",
  name: "Barrier + Beyond | Clean Niacinamide & Hyaluronic Acid Serum",
  brandToken: "b_aswupcvq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7022af4eef00ae8698ba273905382e5f57dc5d1445dd49c222d63b34fbe09214.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f07652f17774963558166458b45944247c1b0ffb3b3134b59318d7bff51ff42b.jpeg",
    "https://cdn.faire.com/fastly/6703a3990b61d029aaf0c58d6b85cb9806ef234d93b65dbf268fc265e73c41be.jpeg",
    "https://cdn.faire.com/fastly/7ea70e8df90db6d423cb09aab34cfd0da807a717fd753c69fdcdaf6bfcdb7797.jpeg",
    "https://cdn.faire.com/fastly/80c53e2a646dac0ac66335ff0b802ebf0a1685fede8ec6b10e7c8ed8e0d8b88e.jpeg",
    "https://cdn.faire.com/fastly/9b2da5ef84e85e76b91d3a1a96d85d5a4e751bde4288e46ea64180bd5af1f64e.jpeg",
    "https://cdn.faire.com/fastly/fe1676a13ceb47b8c2502b0bac8add3a49d557109e1e49fdfc2d4615b9f17f99.jpeg",
    "https://cdn.faire.com/fastly/5bf9d6aa18960bbc6799905fd4fbb6ff994689bb115eeed0f96987b8e79ead58.jpeg",
  ],
  priceDollars: 37.5,
  description:
    'A natural hydrating serum for redness, dryness & sensitive skin, powered by niacinamide and hyaluronic acid to strengthen the skin barrier. This clean beauty essential is like an IV for your skin, delivering a blend of plant peptide, and sources of vitamins B3 and C, along with nutrients that mimic the effects of vitamins A, E, and K, each working to nourish, shield, and support a healthy skin barrier. Ideal for boutiques and spas looking for a multitasking solution that appeals to customers struggling with dryness, redness, dullness, or early signs of aging.\n\nKey Benefits:\n- Niacinamide calms redness, smooths tone, and minimizes pores\n- Hyaluronic acid plumps and deeply hydrates\n- Defends skin from environmental stressors\n- Strengthens the skin barrier for resilient, healthy skin\n- Vegan | Cruelty-Free | Non-Toxic\n\n"Like an “IV drip for the skin,” this serum nourishes and restores without heaviness, leaving skin hydrated, resilient, and radiant.\n\nBest Suited For: All Skin Types\nSize: 1 fl oz / 30 ml\nConsistency: Water Serum',
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:04.247Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
